import { useState } from "react";
import { FormLayout, TextField } from "@shopify/polaris";
import { PAYEE_FORMAT, bankFromClabe } from "../../utility/egresos";

// The fields of a tercero, shared by "Nuevo tercero" and "Editar tercero" so
// both check the same formats. A format error shows once the field is left
// (or immediately when a CLABE is complete), not on every keystroke. Name and
// CLABE are required. The bank is not asked: it comes from the CLABE (and the
// bank's own verification).
export default function PayeeFields({ f, set }) {
  const [touched, setTouched] = useState({});
  const touch = (k) => () => setTouched((t) => ({ ...t, [k]: true }));
  const err = (k) => ((touched[k] || (k === "clabe" && f.clabe?.length === 18)) && PAYEE_FORMAT[k](f[k])) || undefined;
  const bank = bankFromClabe(f.clabe);

  return (
    <FormLayout>
      <TextField label="Nombre o razón social" value={f.name} onChange={set("name")} autoComplete="off" requiredIndicator />
      <TextField label="Apodo" value={f.nickname} onChange={set("nickname")} autoComplete="off" placeholder="Clara" />
      <FormLayout.Group>
        <TextField
          label="RFC"
          value={f.rfc}
          onChange={(v) => set("rfc")(v.toUpperCase().replace(/\s/g, ""))}
          onBlur={touch("rfc")}
          error={err("rfc")}
          maxLength={13}
          autoComplete="off"
        />
        <TextField
          label="CURP"
          value={f.curp}
          onChange={(v) => set("curp")(v.toUpperCase().replace(/\s/g, ""))}
          onBlur={touch("curp")}
          error={err("curp")}
          maxLength={18}
          autoComplete="off"
        />
      </FormLayout.Group>
      <FormLayout.Group>
        <TextField
          label="CLABE"
          requiredIndicator
          value={f.clabe}
          onChange={(v) => set("clabe")(v.replace(/\D/g, "").slice(0, 18))}
          onBlur={touch("clabe")}
          error={err("clabe")}
          helpText={!err("clabe") && bank ? bank : undefined}
          inputMode="numeric"
          autoComplete="off"
        />
        <TextField label="Titular de la cuenta" value={f.bank_holder_name} onChange={set("bank_holder_name")} autoComplete="off"
          helpText="Solo si la cuenta está a nombre de otra persona"
        />
      </FormLayout.Group>
      <TextField
        label="Concepto SPEI fijo"
        value={f.spei_concept}
        onChange={set("spei_concept")}
        onBlur={touch("spei_concept")}
        error={err("spei_concept")}
        maxLength={40}
        autoComplete="off"
        helpText="Si quien recibe exige una referencia exacta (p. ej. el número de cuenta de AMEX), cada SPEI lleva solo esto"
      />
      <FormLayout.Group>
        <TextField
          label="Teléfono"
          value={f.phone}
          onChange={set("phone")}
          onBlur={touch("phone")}
          error={err("phone")}
          type="tel"
          autoComplete="off"
        />
        <TextField
          label="Correo"
          value={f.email}
          onChange={(v) => set("email")(v.trim())}
          onBlur={touch("email")}
          error={err("email")}
          type="email"
          autoComplete="off"
        />
      </FormLayout.Group>
    </FormLayout>
  );
}
